module.exports = __webpack_public_path__ + "img/software-bg.92457927.png";